import {getElementByTagName} from '../utils';

const createInfo = (hash) => {
    const footer = getElementByTagName('footer');

    for (let item of Array.from(footer.childNodes)) {
        if (item.classList.contains('info')) {
            return;
        }
    }

    const p = document.createElement('p');
    p.classList.add('info');
    p.innerHTML = generateInfoText();

    footer.prepend(p);
};

const generateInfoText = () => `О доставке и способе оплаты договоримся лично.<br> Нажимайте на кнопку «купить».`;


export default createInfo;
